/* ============================================================
   pn-turntable-bridge.js — tracklist buttons -> the 3D deck.

   This is the ONLY handler for .pn-track-trigger clicks that matters. It runs
   in the CAPTURE phase and calls stopPropagation(), so nothing further down
   ever sees the event — paranoise-player.js has a delegated play handler of
   its own that is dead on these pages for exactly that reason. Anything to do
   with what a track button does belongs here.

   It used to call P.open() on every click, which re-cues the record and starts
   the track from the beginning. That made the pause icon a lie: the button
   correctly turned into a pause symbol while the track played, but pressing it
   restarted the track instead of pausing, and the only way to stop the music
   was to open the deck and use its own play/pause. Clicking the row that is
   ALREADY on the deck now toggles it — pause, then resume from where it
   stopped — and any other row still cues that row.

   The deck is imported lazily on the first click and cached, so the module and
   its model are only fetched when someone actually plays something.
   ============================================================ */
let deck = null, loading = null;

function player() {
  if (deck) return Promise.resolve(deck);
  if (!loading) {
    loading = import(
      (window.PN_TT_ASSETS || {}).player ||
      new URL('./pn-turntable.js', import.meta.url).href
    ).then(m => (deck = m.PNTurntable));
  }
  return loading;
}

document.addEventListener('click', function (e) {
  const btn = e.target.closest && e.target.closest('.pn-track-trigger');
  if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
  const url = btn.dataset.url;
  if (!url) return;

  e.preventDefault();
  e.stopPropagation();

  const side  = (btn.dataset.side || '').trim();
  const title = (btn.dataset.title || btn.dataset.record || '').trim();

  player().then(P => {
    /* Same record already cued: pause / resume rather than starting over.
       Compared on url because that is what the deck actually loaded, so it
       still holds when two rows share a title. */
    const cur = P.state && P.state.track;
    if (cur && cur.url === url && typeof P.togglePlayback === 'function') {
      P.togglePlayback();
      return;
    }
    P.open({
      url,
      title: side ? side + ' — ' + title : title,
      subtitle: [btn.dataset.artist, btn.dataset.record].filter(Boolean).join(' — '),
      artwork: window.PN_PRODUCT_ARTWORK || null,
      rpm: +(btn.dataset.rpm || 0) || 33.333
    });
  });
}, true);
